import React from 'react';
import { css } from '@emotion/core';
import throttle from 'lodash.throttle';

class DescriptionComponent extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            offset: 0,
            top: 0,
            width: 0,
            fixed: false,
            active: false,
            parent: {},
        };

        this.outer = React.createRef();
        this.wrapper = React.createRef();
        this.inner = React.createRef();

        this.handleResize = this.handleResize.bind(this);
        this.handleResizeThrottled = throttle(this.handleResize, 250);

        this.setParentRect = this.setParentRect.bind(this);
        this.setParentRectTrottled = throttle(this.setParentRect, 1000);

        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        // this.init();
        // this.addEventListeners();
    }
    componentWillUnmount() {
        this.removeEventListeners();
    }
    addEventListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResizeThrottled);
    }
    removeEventListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResizeThrottled);
    }
    handleResize() {
        this.setParentRect();
    }
    init() {
        this.setParentRect();
    }
    getOffset() {
        const headerdiv = document.querySelector('#mainNavigation div');

        if (!headerdiv) return 0;

        let headerbounds = headerdiv.getBoundingClientRect();
        return (
            headerbounds.bottom + (headerbounds.bottom - headerbounds.height)
        );
    }
    setParentRect() {
        const outerbounds = this.outer.current.getBoundingClientRect();
        const innerbounds = this.inner.current.getBoundingClientRect();

        const offset = this.getOffset();

        const newState = {
            offset: offset,
            width: outerbounds.width,
            height: innerbounds.height,
            parent: {
                top: outerbounds.top + window.scrollY,
                height: outerbounds.height,
            },
        };
        newState.active = false; //newState.parent.height > window.innerHeight * 0.7;

        this.setState(newState, this.respositionElements);
    }

    handleScroll() {
        this.setParentRectTrottled();
        if (this.state.active === true) {
            this.respositionElements();
        }
    }
    respositionElements() {
        const scrollTop = window.scrollY + this.state.offset;
        const isAfterTop = scrollTop > this.state.parent.top;
        const isBeforeBottom =
            scrollTop <
            this.state.parent.top +
                this.state.parent.height -
                this.state.height;
        if (isAfterTop && isBeforeBottom) {
            this.setState({ fixed: true, top: this.state.offset });
        } else {
            if (isAfterTop) {
                this.setState({
                    fixed: false,
                    top: this.state.parent.height - this.state.height,
                });
            }
            if (!isAfterTop) {
                this.setState({ fixed: false, top: 0 });
            }
        }
    }
    render() {
        const { descriptionLabel, descriptionBody } = this.props;
        const { fixed, top, width } = this.state;
        return (
            <div ref={this.outer} css={descriptionWrapper}>
                <div ref={this.wrapper}>
                    <div
                        ref={this.inner}
                        style={{
                            position: fixed ? 'fixed' : 'relative',
                            top: `${top}px`,
                            width: fixed ? `${width}px` : 'auto',
                        }}>
                        <div className="label"><strong>{descriptionLabel}</strong></div>
                        <div className="">{descriptionBody}</div>
                    </div>
                </div>
                <div className="spacer" size="10"></div>
            </div>
        );
    }
}

export default DescriptionComponent;

const descriptionWrapper = css`
    width: 100%;
    // height: 100%;
    position: relative;

    .label + div:not(:empty) {
        margin-top: 0.75em;
    }

    @media (min-width: 1025px) {
        .spacer {
            display: none;
        }
    }
`;
